import styled from 'styled-components';
import { Text, Box } from '@rsos/components/capstone/base';

export const Container = styled(Box).attrs({
  width: '240px',
  backgroundColor: 'background',
  overflow: 'hidden',
})`
  border: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  border-radius: 5px;
  box-shadow: 2px 2px 10px 1px rgba(0, 0, 0, 0.13);
`;

export const TitleBox = styled(Box).attrs({
  padding: '12px 16px',
})``;

export const Title = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
  fontWeight: 'bold',
})``;

export const Row = styled(Box).attrs({
  horizontal: true,
  padding: '12px 16px',
})`
  border-top: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
`;

export const ParticipantInfo = styled(Box).attrs({
  justify: 'center',
  flex: '1 1 auto',
  marginLeft: '16px',
  overflow: 'hidden',
})``;

export const ParticipantName = styled(Box).attrs({
  height: '22px',
  ellipsis: true,
})`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 14px;
  line-height: 22px;
`;

export const ParticipantDesc = styled(Box).attrs({
  horizontal: true,
  minHeight: '12px',
  align: 'center',
  marginTop: '2px',
})`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 12px;
  line-height: 1.2;
`;

export const PhoneNumber = styled(Text).attrs({
  inline: true,
  marginLeft: '5px',
  color: 'secondaryText',
  size: 'small',
})``;
